import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "../pages/authPages/Login";
import RegisterPage from "../pages/authPages/Register";

import ProtectedRoute from "./ProtectedRoute";
import { canUseCompanyFeatures } from "../utilities/userAccess";
import { ToastContainer } from "react-toastify";

import ForgotPassword from "../pages/authPages/ForgotPassword";
import ResetPassword from "../pages/authPages/ResetPassword";
import SSOAuthorize from "../pages/authPages/SSOAuthorize";
import ProfilePage from "../pages/ProfilePage";
import OtpWrapper from "../pages/authPages/smsServices/OtpWrapper";
import PendingUsers from "../pages/admin/PendingUsers";

import CompanyRolePage from "../pages/CompanyRolePage";
import NotFoundPage from "../pages/errorpages/NotFoundPage";
import WalletPage from "../pages/accountsPages/WalletPage";
import MainLayout from "../pages/layoutpage/MainLayout";

import Dashboard from "../pages/admin/DashBoard";
import MotherDashboard from "../pages/Dashboard/MotherDashboard";
import SisterCompanyDashboard from "../pages/Dashboard/SisterCompanyDashboard";
import CompanyLandingPage from "../pages/Home/CompanyLandingPage";
import SecurityModule from "../pages/SecurityManagement/SecurityMoudle";
import SystemSettings from "../pages/SystemSettings/SystemSettings ";
import HomeLayout from "../pages/HomeLayout/HomeLayout";
import ContactUs from "../pages/ContactUs/ContactUs";
import AboutUs from "../pages/AboutUs/AboutUs";
import RoleSelection from "../pages/RoleSelection/RoleSelection";
import RoleRequestHistory from "../pages/RoleRequestHistory/RoleRequestHistory";
import RoleRequestDetail from "../pages/RoleRequestHistory/RoleRequestDetail";
import ApproverDashboard from "../pages/ApproverDashboard/ApproverDashboard";
import IconicGallery from "../pages/IconicGallery/IconicGallery";
import IconicBlog from "../pages/IconicBlog/IconicBlog";
import IconicBlogDetails from "../pages/IconicBlog/IconicBlogDetails";
import IconicFAQ from "../pages/IconicFAQ/IconicFAQ";
import ManageRolesPage from "../pages/admin/ManageRolesPage";
import MlmLevelsConfigPage from "../pages/admin/MlmLevelsConfigPage";
import MlmTreePage from "../pages/admin/MlmTreePage";
import PointExchangeRatePage from "../pages/admin/PointExchangeRatePage";
import CompaniesManagePage from "../pages/admin/CompaniesManagePage";
import OfficesPage from "../pages/admin/OfficesPage";
import ApiDocsPage from "../pages/admin/ApiDocsPage";
import DirectorOfficePortal from "../pages/DirectorOfficePortal/DirectorOfficePortal";
import OfficePortalProductDetail from "../pages/DirectorOfficePortal/OfficePortalProductDetail";
import PrivacyPolicy from "../components/FooterContent/PrivacyPolicy";
import TermsAndConditions from "../components/FooterContent/TermsAndConditions";
import Sitemap from "../components/FooterContent/Sitemap";
import OurStory from "../pages/OurStory/OurStory";
import MissionVision from "../pages/MissionVision/MissionVision";
import OurCoreValues from "../pages/OurCoreValues/OurCoreValues";
import BoardOfDirectors from "../pages/BoardOfDirectors/BoardOfDirectors";
import BoardOfDirectorsDetails from "../pages/BoardOfDirectors/BoardOfDirectorsDetails";
import ExecutiveCommittee from "../pages/ExecutiveCommittee/ExecutiveCommittee";
import WhyChooseUs from "../pages/WhyChooseUs/WhyChooseUs";
import Testimonials from "../pages/Testimonials/Testimonials";
import CompanyInfoDetails from "../pages/CompanyInfoDetails/CompanyInfoDetails";
import IconicGalleryImages from "../pages/IconicGalleryImage/IconicGalleryImages";

import { clearSession, readStoredJson } from "../utilities/session";

const RouteAll = () => {
  // Safe JSON.parse to handle null values
  const user = readStoredJson("user", null);

  const onLogout = () => {
    clearSession();
    window.location.reload();
  };
  return (
    <>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        style={{ zIndex: "9999" }}
      />
      <Routes>
        {/* ---------- PUBLIC ROUTES ------------ */}
        <Route path="/" element={<CompanyLandingPage />} />
        <Route element={<HomeLayout />}>
          <Route path="/company/:id" element={<CompanyInfoDetails />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/about-us" element={<AboutUs />} />

          <Route path="/gallery" element={<IconicGallery />} />
          <Route path="/gallery/:company" element={<IconicGalleryImages />} />
          <Route path="/blogs" element={<IconicBlog />} />
          <Route path="/blogs/:slug" element={<IconicBlogDetails />} />
          <Route path="/faq" element={<IconicFAQ />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          {/* Reason: keeps legacy links working when the Apache 301 is unavailable (e.g. npm start). */}
          <Route
            path="/privacy-policy"
            element={<Navigate to="/privacy" replace />}
          />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/about-us/our-story" element={<OurStory></OurStory>} />
          <Route
            path="/about-us/mission-vision"
            element={<MissionVision></MissionVision>}
          />
          <Route
            path="/about-us/our-core-values"
            element={<OurCoreValues></OurCoreValues>}
          />
          <Route
            path="/about-us/all-directors"
            element={<BoardOfDirectors></BoardOfDirectors>}
          />
          <Route
            path="/about-us/board-of-directors/details/:id"
            element={<BoardOfDirectorsDetails></BoardOfDirectorsDetails>}
          />
          <Route
            path="/about-us/executive-committee"
            element={<ExecutiveCommittee></ExecutiveCommittee>}
          />
          <Route
            path="/about-us/why-choose-us"
            element={<WhyChooseUs></WhyChooseUs>}
          />
          <Route
            path="/about-us/testimonials"
            element={<Testimonials></Testimonials>}
          />
        </Route>

        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/sso/authorize" element={<SSOAuthorize />} />

        {/* ---------- MAIN LAYOUT WRAPPER ---------- */}
        <Route
          element={
            <ProtectedRoute skipRoleCheck={true}>
              <MainLayout
                user={user}
                onLogout={onLogout}
                sidebarCollapsed={false}
              />
            </ProtectedRoute>
          }
        >
          <Route path="/profile" element={<ProfilePage />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/mother-dashboard"
            element={
              <ProtectedRoute>
                <MotherDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/company-dashboard/:companyId"
            element={
              <ProtectedRoute>
                <SisterCompanyDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/office-portal/:slug"
            element={
              <ProtectedRoute>
                <DirectorOfficePortal />
              </ProtectedRoute>
            }
          />
          <Route
            path="/office-portal/:slug/products/:productId"
            element={
              <ProtectedRoute>
                <OfficePortalProductDetail />
              </ProtectedRoute>
            }
          />

          <Route
            path="/user-roles"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <CompanyRolePage />
              </ProtectedRoute>
            }
          />
          {/*  Manage Roles */}
          <Route
            path="/manage-roles"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <ManageRolesPage />
              </ProtectedRoute>
            }
          />
          {/* MLM Tree Config */}
          <Route
            path="/admin/mlm-levels"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <MlmLevelsConfigPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/mlm-tree"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <MlmTreePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/offices"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <OfficesPage />
              </ProtectedRoute>
            }
          />
          {/* security Module */}
          <Route
            path="/security-management"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <SecurityModule />
              </ProtectedRoute>
            }
          />
          {/* System Settings Module */}
          <Route
            path="/system-settings"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <SystemSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/api-docs"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <ApiDocsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/companies-manage"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <CompaniesManagePage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/point-exchange-rates"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <PointExchangeRatePage />
              </ProtectedRoute>
            }
          />

          <Route path="/otp" element={<OtpWrapper />} />

          <Route
            path="/pending-users"
            element={
              <ProtectedRoute canAccess={canUseCompanyFeatures}>
                <PendingUsers />
              </ProtectedRoute>
            }
          />

          {/* Role Selection  */}
          <Route path="/role_selection" element={<RoleSelection />} />
          <Route path="/role-requests" element={<RoleRequestHistory />} />
          <Route path="/role-requests/:id" element={<RoleRequestDetail />} />
          <Route path="/approver-dashboard" element={<ApproverDashboard />} />

          {/* account */}
          {/* wallet */}
          <Route
            path="/wallet"
            element={
              <ProtectedRoute>
                <WalletPage />
              </ProtectedRoute>
            }
          />
        </Route>

        {/* ---------- 404 ---------- */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
};

export default RouteAll;
